import { useEffect, useState } from 'react'
import { configValue } from '../../utils'

export default function ClientVersion() {
  console.log('ClientVersion rendered')

  const [displayedVersion, setDisplayedVersion] = useState()

  useEffect(() => {
    const configVersion = configValue('CLIENT VERSION')
    if (configVersion !== displayedVersion) {
      setDisplayedVersion(configVersion)
    }
  },[displayedVersion])

  return <span style={{ marginRight: '10px' }}>{displayedVersion}</span>
}
